module.exports = __webpack_public_path__ + "img/day-18.402ef393.png";